const e = {
  buttonClose: {
    id: "design_system_button_close",
    defaultMessage: "Close"
  },
  buttonClear: {
    id: "design_system_button_clear",
    defaultMessage: "Clear"
  },
  buttonLoading: {
    id: "design_system_button_loading",
    defaultMessage: "Loading"
  },
  rating: {
    id: "design_system_rating_score",
    defaultMessage: "Rating of {rating} out of {maxRating} stars"
  },
  inputPhoneCountryCode: {
    id: "design_system_input_phone_country_code",
    defaultMessage: "Country code"
  },
  cardCarouselControllerPrevious: {
    id: "design_system_card_carousel_controller_previous",
    defaultMessage: "Previous - Scroll carousel left"
  },
  cardCarouselControllerNext: {
    id: "design_system_card_carousel_controller_next",
    defaultMessage: "Next - Scroll carousel right"
  },
  cardCarouselShowingSlides: {
    id: "design_system_card_carousel_showing_slides",
    defaultMessage: "Showing slides {first} through {last}"
  },
  searchPlaceholder: {
    id: "design_system_search_placeholder",
    defaultMessage: "Search for an item..."
  },
  carouselPause: {
    id: "design_system_carousel_pause",
    defaultMessage: "Pause carousel"
  },
  carouselPlay: {
    id: "design_system_carousel_play",
    defaultMessage: "Play carousel"
  },
  carouselButtonLabel: {
    id: "design_system_carousel_button_label",
    defaultMessage: "Show image {index}"
  },
  countdownEnd: {
    id: "design_system_countdown_end",
    defaultMessage: "The countdown finishes on: {endDate}"
  }
};
export {
  e as default
};
